import { z } from 'zod';

const optionalUuid = z
    .string()
    .trim()
    .optional()
    .nullable()
    .refine((value) => !value || z.string().uuid().safeParse(value).success, {
        message: 'Invalid UUID',
    });

export const IntegrationMessagesPageFilterFormSchema = z.object({
    tenantId: z.string().nullable(),
    type: z.string().nullable(),
    id: optionalUuid,
    aggregateId: optionalUuid,
    externalId: z.string().trim().optional().nullable(),
});

export type IntegrationMessagesPageFilterFormData = z.infer<
    typeof IntegrationMessagesPageFilterFormSchema
>;
